/* eslint-disable lingui/no-unlocalized-strings */
import * as Departments from './departments';
const hoursOfOperation = [{
  dayOfWeek: {
    start: 1,
    // Monday
    end: 5 // Friday
  },
  hours: {
    start: 5,
    // 5AM
    end: 19 // 7PM
  },
  timezone: 'America/Los_Angeles',
  abbreviatedTimezone: 'PT'
}, {
  dayOfWeek: {
    start: 6,
    // Saturday
    end: 7 // Sunday
  },
  hours: {
    start: 6,
    // 6AM
    end: 17 // 5PM
  },
  timezone: 'America/Los_Angeles',
  abbreviatedTimezone: 'PT'
}];
const homeImprovementMerchantSupportHours = [{
  dayOfWeek: {
    start: 1,
    // Monday
    end: 5 // Friday
  },
  hours: {
    start: 5,
    // 5AM
    end: 20 // 8PM
  },
  timezone: 'America/Los_Angeles',
  abbreviatedTimezone: 'PT'
}, {
  dayOfWeek: {
    start: 6,
    // Saturday
    end: 7 // Sunday
  },
  hours: {
    start: 6,
    // 6AM
    end: 17 // 5PM
  },
  timezone: 'America/Los_Angeles',
  abbreviatedTimezone: 'PT'
}];
const autoFinancePreQualificationHours = [{
  dayOfWeek: {
    start: 1,
    // Monday
    end: 5 // Friday
  },
  hours: {
    start: 9,
    // 9AM
    end: 17 // 5PM
  },
  timezone: 'America/Los_Angeles',
  abbreviatedTimezone: 'PT'
}];
const depositCreditBuilderVipSupportHours = [{
  dayOfWeek: {
    start: 1,
    // Monday
    end: 5 // Friday
  },
  hours: {
    start: 6,
    // 6AM
    end: 18 // 6PM
  },
  timezone: 'America/Los_Angeles',
  abbreviatedTimezone: 'PT'
}, {
  dayOfWeek: {
    start: 6,
    // Saturday
    end: 7 // Sunday
  },
  hours: {
    start: 8,
    // 8AM
    end: 17 // 5PM
  },
  timezone: 'America/Los_Angeles',
  abbreviatedTimezone: 'PT'
}];
const defaultSupportEmail = 'support@upgrade.com';
const bankingSupportEmail = 'banking@upgrade.com';
const autoServicingSupportEmail = 'autoservicing@upgrade.com';
const flexPaySupportEmail = 'customercare@upgrade.com';
const depositDisputes = 'depositdisputes@upgrade.com';
export default {
  [Departments.CUSTOMER_SERVICE]: {
    email: defaultSupportEmail,
    number: '+18442077781',
    hoursOfOperation
  },
  [Departments.CREDIT_OPERATIONS]: {
    email: defaultSupportEmail,
    number: '+18554665995',
    hoursOfOperation
  },
  [Departments.FLEX_PAY_SUPPORT]: {
    email: flexPaySupportEmail,
    number: '+18442575400',
    hoursOfOperation
  },
  [Departments.FLEX_PAY_SUPPORT_FR]: {
    email: 'soutien@upgrade.com',
    number: '+18442575400',
    hoursOfOperation
  },
  [Departments.ACCOUNT_SERVICING]: {
    email: 'accountservicing@upgrade.com',
    number: '+18448999931',
    hoursOfOperation
  },
  [Departments.CUSTOMER_SUPPORT]: {
    email: defaultSupportEmail,
    number: '+18443193909',
    hoursOfOperation
  },
  [Departments.CUSTOMER_SUPPORT_ALT]: {
    default: defaultSupportEmail,
    number: '+18446330742',
    hoursOfOperation
  },
  [Departments.UNIVERSAL_CREDIT_CUSTOMER_SUPPORT]: {
    email: 'support@universal-credit.com',
    number: '+18774189765',
    hoursOfOperation
  },
  [Departments.PCL_CUSTOMER_SUPPORT]: {
    email: defaultSupportEmail,
    number: '+18445585687',
    hoursOfOperation
  },
  [Departments.DEPOSIT_CUSTOMER_SUPPORT]: {
    email: bankingSupportEmail,
    number: '+18337605062',
    hoursOfOperation
  },
  [Departments.DEPOSIT_ISSUED_CUSTOMER_SUPPORT]: {
    email: bankingSupportEmail,
    number: '+18443193692',
    hoursOfOperation
  },
  [Departments.DEPOSIT_SPECIFIC_CUSTOMER_SUPPORT]: {
    email: 'depositsupport@upgrade.com',
    number: '+18443193692',
    hoursOfOperation
  },
  [Departments.LOAN_SERVICING_HARDSHIP]: {
    email: defaultSupportEmail,
    number: '+18888735960',
    hoursOfOperation
  },
  // Deprecated. Use PCL_CARD_ISSUES instead.
  [Departments.PCL_LOST_CARD]: {
    number: '+18337605065',
    hoursOfOperation
  },
  [Departments.PCL_CARD_ISSUES]: {
    number: '+18337605065',
    hoursOfOperation
  },
  [Departments.PCL_SERVICING]: {
    email: defaultSupportEmail,
    number: '+18445585687',
    hoursOfOperation
  },
  [Departments.DISPUTE_UPGRADE_CARD]: {
    email: defaultSupportEmail,
    number: '+18443193331',
    hoursOfOperation
  },
  [Departments.HOME_IMPROVEMENT_CUSTOMER_SUPPORT]: {
    email: defaultSupportEmail,
    number: '+18447195742',
    hoursOfOperation
  },
  [Departments.HOME_IMPROVEMENT_PODS_SUPPORT]: {
    email: defaultSupportEmail,
    number: '+18445476020',
    hoursOfOperation: homeImprovementMerchantSupportHours
  },
  [Departments.HOME_IMPROVEMENT_DISPUTES_SUPPORT]: {
    email: defaultSupportEmail,
    number: '+18443470509',
    hoursOfOperation: homeImprovementMerchantSupportHours
  },
  [Departments.HOME_IMPROVEMENT]: {
    email: 'merchantsupport@upgrade.com',
    number: '+18443193368',
    hoursOfOperation: homeImprovementMerchantSupportHours
  },
  [Departments.AUTO_SERVICING]: {
    email: autoServicingSupportEmail,
    number: '+18555981271',
    hoursOfOperation
  },
  [Departments.AUTO_FINANCE_PRE_QUALIFICATION]: {
    email: 'prequalification@upgrade.com',
    number: '+18885225189',
    hoursOfOperation: autoFinancePreQualificationHours
  },
  [Departments.CARDS_SUPPORT_HOTLINE]: {
    email: defaultSupportEmail,
    number: '+18005045706',
    hoursOfOperation
  },
  [Departments.DEPOSIT_CARDS_AND_ACH_TRANSFERS_DISPUTES]: {
    email: depositDisputes,
    number: '+18445512442',
    hoursOfOperation
  },
  [Departments.DEPOSIT_CREDIT_BUILDER_VIP_SUPPORT]: {
    email: defaultSupportEmail,
    number: '+18669965641',
    hoursOfOperation: depositCreditBuilderVipSupportHours
  }
};
//# sourceMappingURL=department-information.js.map